// extracted by extract-css-chunks-webpack-plugin
module.exports = {"ad":"ad-1BT0UHlg","box":"box-1FUIvUbw","footer":"footer-26TizdBs"};